import React, { Component, useEffect } from 'react';
import axios from 'axios';
import './styles/style.css';
import { Route, BrowserRouter, Redirect, Switch, useLocation } from 'react-router-dom';
import SignUp from './components/pages/SignUp';
import Login from './components/pages/Login';
import RestorePassword from './components/pages/RestorePassword';
import { CheckoutPage } from './components/pages/CheckoutPage';
import DerebanProductPage from './components/pages/DerebanProductPage';
import GeneralAdminOrdersPage from './components/new/admin/order/GeneralAdminOrdersPage';
import AdminProductsPage from './components/pages/AdminProductsPage/ResponsiveAdminProductsPage';
import AdminUsersPage from './components/new/admin/user/AdminUsersPage';
import AdminUserDetailPage from './components/new/admin/user/AdminUserDetailPage';
import AdminBankAccountsPage from './components/new/admin/bank/AdminBankAccountsPage';
import AdminPaymentsPage from './components/new/admin/bank/AdminPaymentsPage';
import AdminFilesPage from './components/new/admin/files/AdminFilesPage';
import IncomingShipmentsPage from './components/new/admin/incoming/IncomingShipmentsPage';
import IncomingShipmentDetailPage from './components/new/admin/incoming/IncomingShipmentDetailPage';
import AdminBarcodeManagementPage from './components/new/admin/barcodes/AdminBarcodeManagementPage';
import PreOrderPage from './components/pages/PreOrderPage';
import GeneralProductsPage from './components/new/GeneralProductsPage';
import UserPersonalCabinetPage from './components/pages/UserPersonalCabinetPage';
import OrderDetailsPage from './components/new/orders/OrderDetailsPage';
import ClientInfoPage from './components/pages/ClientInfoPage';
import ProductPage from './components/pages/ProductPage';
import OrderConfirmationPage from './components/new/orderConfirmation/OrderConfirmationPage';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import './styles/signup-checkbox-black.css';
import AdminOrderPage from './components/new/admin/order/AdminOrderPage';
import AdminRouteLayout from './components/shared/AdminRouteLayout';
import AdminPromoCodesPage from './components/promo/AdminPromoCodesPage';
import ProcurementAuditPage from './components/new/admin/procurement/ProcurementAuditPage';
import { API_BASE_URL } from './shared/apiConfig';

const SupplierStockPage = React.lazy(() => import('./components/new/admin/supplier/SupplierStockPage'));
const OrderItemsDesignPage = process.env.NODE_ENV === 'development'
  ? React.lazy(() => import('./components/new/admin/order/design/OrderItemsDesignPage'))
  : null;

axios.defaults.baseURL = API_BASE_URL;

const AUTH_PATHS = ['/login', '/signup', '/restore-password'];

const ReturnUrlSaver = () => {
  const location = useLocation();
  useEffect(() => {
    const { pathname, search } = location;
    if (!AUTH_PATHS.includes(pathname)) {
      localStorage.setItem('currentUrl', pathname + search);
    }
  }, [location]);
  return null;
};

class App extends Component {
  render() {
    return (
      <BrowserRouter>
        <ReturnUrlSaver />
        <AdminRouteLayout>
          <Switch>
            <Route exact path='/' component={GeneralProductsPage} />
            <Route exact path='/boxes/' component={GeneralProductsPage} />
            <Route exact path='/signup' component={SignUp} />
            <Route exact path='/login' component={Login} />
            <Route exact path='/restore-password' component={RestorePassword} />
            <Route exact path='/checkout' component={CheckoutPage} />
            <Route exact path='/dereban-product/:id' component={DerebanProductPage} />
            <Route exact path='/product/:id' render={routeProps => (
              <ProductPage key={routeProps.match.params.id} {...routeProps} />
            )} />
            <Route exact path='/pre-order' component={PreOrderPage} />
            <Route exact path='/admin/users' component={AdminUsersPage} />
            <Route exact path='/admin/users/:userId' component={AdminUserDetailPage} />
            <Route exact path='/admin/orders/new' component={GeneralAdminOrdersPage} />
            {OrderItemsDesignPage && <Route exact path='/admin/order-items-designs' render={() => (
              <React.Suspense fallback={<div className='p-4'>Завантаження макетів…</div>}>
                <OrderItemsDesignPage />
              </React.Suspense>
            )} />}
            <Route exact path='/admin/order/:orderId' render={routeProps => (
              <AdminOrderPage {...routeProps} key={routeProps.match.params.orderId} />
            )} />
            <Route exact path='/admin/promo-codes' component={AdminPromoCodesPage} />
            <Route exact path='/admin/products' component={AdminProductsPage} />
            <Route exact path='/admin/procurement' component={ProcurementAuditPage} />
            <Route exact path='/admin/supplier-stock' render={() => (
              <React.Suspense fallback={<div className='container py-4' role='status'>Завантаження…</div>}>
                <SupplierStockPage />
              </React.Suspense>
            )} />
            <Route exact path='/admin/barcodes' component={AdminBarcodeManagementPage} />
            <Route exact path='/admin/bank-accounts' component={AdminBankAccountsPage} />
            <Route exact path='/admin/payments' component={AdminPaymentsPage} />
            <Route exact path='/admin/incoming-shipments' component={IncomingShipmentsPage} />
            <Route
              exact
              path='/admin/incoming-shipments/:shipmentId'
              component={IncomingShipmentDetailPage}
            />
            <Route exact path='/admin/files' component={AdminFilesPage} />
            <Route exact path='/user/personal-cabinet' component={UserPersonalCabinetPage} />
            <Route exact path='/user/order/:orderId' component={OrderDetailsPage} />
            <Route exact path='/info/:eventKey' component={ClientInfoPage} />
            <Route exact path='/order/confirmation/:uuid' component={OrderConfirmationPage} />
            <Redirect from='/boxes/:categories' to='/boxes?categoryIds=:categories' />
            <Redirect from='/api/v1/:url' to='/api/v1/:url' />
            <Redirect from='/' to='/boxes/' />
          </Switch>
        </AdminRouteLayout>
      </BrowserRouter>
    );
  }
}

export default App;
